"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DynaNodeMessage_1 = require("../DynaNodeMessage/DynaNodeMessage");
var DynaNodeAddress_1 = require("../DynaNodeAddress/DynaNodeAddress");
var createDynamicDynaNodeAddress_1 = require("../utils/createDynamicDynaNodeAddress");
var DynaNodeConnection = /** @class */ (function () {
    function DynaNodeConnection(config) {
        var _this = this;
        this.config = config;
        this._connectionId = createDynamicDynaNodeAddress_1.createDynamicDynaNodeAddress();
        this._handlerIncomingMessage = function (data) {
            var message = new DynaNodeMessage_1.DynaNodeMessage();
            if (message.unPack(data)) {
                message.from = _this._calcFromAddress(message); // Overwrite it! security issue!
                message.dynaNodeInfo.serverInputTime = new Date;
                message.dynaNodeInfo.fromIpAddress = _this.remoteAddress;
                message._addTrace('DynaNode/ServerWSConnection/RECEIVE_SERVER', "DynaNode: Message incoming message on WS connection");
                _this.config.onMessage(message);
            }
            else {
                _this.config.onError({
                    section: 'DynaNodeConnection(server)/handlerIncomingMessage',
                    code: 16102307,
                    message: 'DynaNode: Connection: Incoming message cannot be parsed, probably is corrupted',
                    data: { data: data, message: message },
                });
            }
        };
        this._handleConnectionClose = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_a = _this.config).onConnectionClose.apply(_a, args);
        };
        this.entityIOSocket = this.config.entityIOSocket;
        this.entityIOSocket.on('message', this._handlerIncomingMessage);
        this.entityIOSocket.on('close', this._handleConnectionClose);
        var remoteAddress = this.entityIOSocket.request.connection.remoteAddress;
        var forwardedAddress = // needed for environments with routers
         this.entityIOSocket.request.headers["x-forwarded-for"]
            && this.entityIOSocket.request.headers["x-forwarded-for"]
                .split(',')
                .reverse()[0]
                .trim();
        this.remoteAddress = forwardedAddress || remoteAddress || '';
    }
    Object.defineProperty(DynaNodeConnection.prototype, "connectionId", {
        get: function () {
            return this._connectionId;
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeConnection.prototype._setConnectionId = function (connectionId) {
        this._connectionId = connectionId;
    };
    // send to client
    DynaNodeConnection.prototype.send = function (message, cbCompleted) {
        message.dynaNodeInfo.serverOutputTime = new Date;
        // No need to check for the packet size, this is tested on client side.
        this.entityIOSocket.send(// Todo: Bug 2467: The message is sent although the connection is closed from the other side
        message.pack().packet, { compress: true }, // help: https://github.com/socketio/engine.io#socket
        cbCompleted);
    };
    DynaNodeConnection.prototype.close = function () {
        this.entityIOSocket.close();
    };
    DynaNodeConnection.prototype._calcFromAddress = function (message) {
        var to = new DynaNodeAddress_1.DynaNodeAddress(message.to);
        return this._connectionId + "@" + to.serverAddress;
    };
    return DynaNodeConnection;
}());
exports.DynaNodeConnection = DynaNodeConnection;
//# sourceMappingURL=DynaNodeConnection.js.map